import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import LocalDrinkIcon from '@mui/icons-material/LocalDrink'
import FastfoodIcon from '@mui/icons-material/Fastfood'
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

const AidStationCard = styled(Card)(({ theme }) => ({ marginBottom: theme.spacing(0.5) }))

export default function AidStationInfo ({ }) {
  const { t } = useTranslation('raceGuide')
  return (
    <>
      <Typography variant='body1' paragraph sx={{ color: 'text.secondary', mb: 2 }}>
        {t('aidStation.intro')}
      </Typography>

      {/* Drinks Only Section */}
      <AidStationCard>
        <CardContent sx={{ py: '8px !important' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 1
            }}
          >
            <LocalDrinkIcon sx={{ mr: 2 }} />
            <Typography variant='h6' component='h3'>
              {t('aidStation.drinksTitle')}
            </Typography>
          </Box>

          <Typography variant='body1' paragraph>
            {t('aidStation.drinksDesc')}
          </Typography>

          <List dense>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.drinksItem1')} />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.drinksItem2')} />
            </ListItem>
          </List>
        </CardContent>
      </AidStationCard>

      {/* Food & Drinks Section */}
      <AidStationCard>
        <CardContent sx={{ py: '8px !important' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 2
            }}
          >
            <FastfoodIcon sx={{ mr: 2 }} />
            <Typography variant='h6' component='h3'>
              {t('aidStation.foodTitle')}
            </Typography>
          </Box>

          <Typography variant='body1' paragraph>
            {t('aidStation.foodDesc')}
          </Typography>

          <List dense>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.foodItem1')} />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.foodItem2')} />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.foodItem3')} />
            </ListItem>
          </List>
        </CardContent>
      </AidStationCard>

      {/* Hot Food Section */}
      <AidStationCard>
        <CardContent sx={{ py: '8px !important' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 2
            }}
          >
            <SoupKitchenIcon sx={{ mr: 2 }} />
            <Typography component='h3' sx={{ fontWeight: 'bold' }}>
              {t('aidStation.hotTitle')}
            </Typography>
          </Box>

          <Typography variant='body1' paragraph>
            {t('aidStation.hotDesc')}
          </Typography>
        </CardContent>
      </AidStationCard>

      {/* Runner Care Section */}
      <AidStationCard>
        <CardContent sx={{ py: '8px !important' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 2
            }}
          >
            <MedicalServicesIcon color='error' sx={{ mr: 2 }} />
            <Typography variant='h6' component='h3'>
              {t('aidStation.careTitle')}
            </Typography>
          </Box>

          <List dense>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.careItem1')} />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.careItem2')} />
            </ListItem>
            <ListItem>
              <ListItemIcon sx={{ minWidth: '35px' }}>
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    bgcolor: '#fff',
                    borderRadius: '50%'
                  }}
                />
              </ListItemIcon>
              <ListItemText primary={t('aidStation.careItem3')} />
            </ListItem>
          </List>
        </CardContent>
      </AidStationCard>
    </>
  )
}
